import React from 'react';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';

import PageTitle from 'components/PageTitle';
import Form from 'components/ForgotPassword/Form';
import Success from 'components/ForgotPassword/Success';
import Alert from '@johnlewispartnership/wtr-ingredients/ingredients/Alert';
import CentralLayout from 'components/CentralLayout';
import styles from './ForgotPassword.scss';

const ForgotPassword = ({ email, onSubmit, onUnloadSuccess }) => (
  <CentralLayout>
    <div className={styles.main}>
      <header className={styles.header}>
        <PageTitle text="Forgotten Details" display underline />
      </header>
      <Routes>
        <Route
          path="success"
          element={<Success email={email} onUnloadSuccess={onUnloadSuccess} />}
        />
        <Route
          path="locked"
          element={
            <>
              <div className={styles.alertWrapper}>
                <Alert
                  ariaLive
                  title="Your account has been locked due to several unsuccessful sign in attempts"
                  message="Please reset your password using the form below"
                  dataTest="accountSoftLockedAlert"
                />
              </div>
              <Form onSubmit={onSubmit} />
            </>
          }
        />
        <Route
          path="expired"
          element={
            <>
              <div className={styles.alertWrapper}>
                <Alert
                  ariaLive
                  title="Sorry, it looks like your password reset link has expired."
                  dataTest="linkExpiredAlert"
                />
              </div>
              <Form onSubmit={onSubmit} linkExpired />
            </>
          }
        />
        <Route path="*" element={<Form onSubmit={onSubmit} />} />
      </Routes>
    </div>
  </CentralLayout>
);

ForgotPassword.propTypes = {
  email: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onUnloadSuccess: PropTypes.func.isRequired,
};

ForgotPassword.defaultProps = {
  email: null,
};

ForgotPassword.displayName = 'ForgotPassword';

export default ForgotPassword;
